import React from 'react';

interface FormInputProps extends React.InputHTMLAttributes<HTMLInputElement> {
  label?: string;
  error?: string;
  helperText?: string;
}

const FormInput: React.FC<FormInputProps> = ({ label, error, helperText, className = '', id, ...props }) => {
  const inputId = id || label?.toLowerCase().replace(/\s+/g, '-');

  const baseInputClasses =
    'w-full px-3 py-2 border rounded-md shadow-sm placeholder-slate-400 focus:outline-none focus:ring-2 focus:border-transparent disabled:bg-slate-100 disabled:text-slate-500';

  const inputClasses = error
    ? `${baseInputClasses} border-red-300 text-red-900 focus:ring-red-500`
    : `${baseInputClasses} border-slate-300 text-slate-900 focus:ring-blue-500`;

  return (
    <div className="space-y-1">
      {label && (
        <label htmlFor={inputId} className="block text-sm font-medium text-slate-700">
          {label}
        </label>
      )}
      <input id={inputId} className={`${inputClasses} ${className}`} {...props} />
      {error && <p className="text-sm text-red-600">{error}</p>}
      {helperText && !error && <p className="text-sm text-slate-500">{helperText}</p>}
    </div>
  );
};

export default FormInput;
